/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _UserPopoverOverviewContainer_user$ref: unique symbol;
export type UserPopoverOverviewContainer_user$ref = typeof _UserPopoverOverviewContainer_user$ref;
export type UserPopoverOverviewContainer_user = {
    readonly id: string;
    readonly username: string | null;
    readonly createdAt: string;
    readonly ignoreable: boolean;
    readonly " $refType": UserPopoverOverviewContainer_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "UserPopoverOverviewContainer_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "username",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "ignoreable",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'a5d813261633a7779df02899fe092b8d';
export default node;
